module.exports = __webpack_public_path__ + "static/media/stemmcellactivegrowthfactor.543ab2e8.png";